import { get, patch, post } from 'core_main/request';
import { GetArticleByIdParameters } from 'core_main/sdk/get_articles/types';

import {
  validateArticlesSearchParameters,
  validateArticleByIdParameters,
  makeArticlesSearchEndpoint,
  makeArticleByIdEndpoint,
  makePostArticleRatingEndpoint,
  makePatchArticleFeedbackEndpoint,
} from './helpers';
import {
  ArticleFeedbackResponseData,
  ArticlesSearchParameters,
  PatchArticleFeedbackParameters,
  PostArticleRatingParameters,
} from './types';

export const fetchArticleById = (parameters: GetArticleByIdParameters) => {
  const validationError = validateArticleByIdParameters(parameters);

  if (validationError) {
    return Promise.reject(validationError);
  }

  return get(makeArticleByIdEndpoint(parameters));
};

export const searchArticlesByKnowledgeBaseId = (
  parameters: ArticlesSearchParameters,
) => {
  const validationError = validateArticlesSearchParameters(parameters);

  if (validationError) {
    return Promise.reject(validationError);
  }

  return get(makeArticlesSearchEndpoint(parameters));
};

export const postArticleRating = (
  parameters: PostArticleRatingParameters,
): Promise<ArticleFeedbackResponseData> => {
  return post(
    makePostArticleRatingEndpoint(parameters.articleId, parameters.lang),
    {
      body: JSON.stringify({
        rating: parameters.rating,
        knowledgeBaseId: parameters.knowledgeBaseId,
      }),
    },
  ).then((res) => res.data);
};

export const patchArticleFeedback = (
  parameters: PatchArticleFeedbackParameters,
): Promise<ArticleFeedbackResponseData> => {
  return patch(
    makePatchArticleFeedbackEndpoint(parameters.articleId, parameters.id),
    {
      body: JSON.stringify({
        suggestedReasons: parameters.suggestedReasons,
        writtenFeedback: parameters.writtenFeedback,
      }),
    },
  ).then((res) => {
    return res.data;
  });
};
